import React, { useState } from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import events from "../events";
import EventCardDetailed from "./EventCardDetailed";
import EventList from "./EventList";
import Footer from "./Footer";
import Header from "./Header";
import ScrollToTop from "./ScrollToTop";
import CssBaseline from "@material-ui/core/CssBaseline";

const FONTBASEURL =
  "https://s3.amazonaws.com/vidyard-client-services/vidyard/events-catalog/fonts/";
const LLCircularBook = {
  fontFamily: "LL Circular",
  fontStyle: "normal",
  fontWeight: 400,
  src: `url("${FONTBASEURL}lineto-circular-book.eot") format("embedded-opentype"),
        url("${FONTBASEURL}lineto-circular-book.woff2") format("woff2"),
        url("${FONTBASEURL}lineto-circular-book.woff") format("woff");`,
};
const LLCircularMedium = {
  fontFamily: "LL Circular",
  fontStyle: "normal",
  fontWeight: 500,
  src: `url("${FONTBASEURL}lineto-circular-medium.eot?#iefix") format("embedded-opentype"),
        url("${FONTBASEURL}lineto-circular-medium.woff2") format("woff2"),
        url("${FONTBASEURL}lineto-circular-medium.woff") format("woff");`,
};
const LLCircularBold = {
  fontFamily: "LL Circular",
  fontStyle: "normal",
  fontWeight: 700,
  src: `url("${FONTBASEURL}lineto-circular-bold.eot?#iefix") format("embedded-opentype"),
        url("${FONTBASEURL}lineto-circular-bold.woff2") format("woff2"),
        url("${FONTBASEURL}lineto-circular-bold.woff") format("woff");`,
};
const LLCircularBlack = {
  fontFamily: "LL Circular",
  fontStyle: "normal",
  fontWeight: 900,
  src: `url("${FONTBASEURL}lineto-circular-black.eot?#iefix") format("embedded-opentype"),
        url("${FONTBASEURL}lineto-circular-black.woff2") format("woff2"),
        url("${FONTBASEURL}lineto-circular-black.woff") format("woff");`,
};

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#5E5CFA",
      dark: "#414DD4",
    },
    text: {
      primary: "#475066",
      secondary: "#5B627D",
    },
  },
  typography: {
    fontFamily: "LL Circular, sans-serif",
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": [
          LLCircularBook,
          LLCircularMedium,
          LLCircularBold,
          LLCircularBlack,
        ],
      },
    },
  },
});

function App() {
  const [eventcards] = useState(events);
  return (
    <React.Fragment>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <Header />
        <Router>
          <ScrollToTop />
          <Switch>
            <Route
              exact
              path="/"
              render={() => <EventList events={eventcards} />}
            />
            <Route
              path="/:sku"
              render={(props) => (
                <EventCardDetailed {...props} events={eventcards} />
              )}
            />
          </Switch>
        </Router>
        <Footer />
      </MuiThemeProvider>
    </React.Fragment>
  );
}

export default App;
